//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
let d=[[[0,"Associative",1,1],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",1],[0,"Curve",0,"Spline",1],[0,"Degree",1,1],[0,"InputCurveOption",1,1],[0,"IsPeriodic",1,1],[0,"MatchKnots",1,1],[0,"SplineMethod",1,1]],[[["number_of_knots"],"GetKnots",{R_:{knots:""}},0,1],[["knots"],"SetKnots",{},1,1],[["number_of_parameters"],"GetParameters",{R_:{parameters:""}},0,1],[["parameters"],"SetParameters",{},1,1],[["spline","method"],"SetNonParametricSpline",{},2,1]],[]];
SPLM.Features.StudioSplineBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StudioSplineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StudioSplineBuilder.Method = Object.freeze({
    "ThroughPoints" : "ThroughPoints", "ByPoles" : "ByPoles"});

SPLM.Features.StudioSplineBuilder.MatchKnotsType = Object.freeze({
    "None" : "None", "Cubic" : "Cubic", "General" : "General"});

SPLM.Features.StudioSplineBuilder.CurveOption = Object.freeze({
    "Retain" : "Retain", "Blank" : "Blank", "Delete" : "Delete"});

export default SPLM;